module.exports = "<mat-spinner [ngClass]=\"position\" *ngIf=\"show\" mode=\"indeterminate\"\n             diameter=\"{{diameter}}\"></mat-spinner>\n"